import React from 'react';

const FinalConfirmation = () => {
  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f6f6f6',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: 0,
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          textAlign: 'center',
          maxWidth: '500px',
          width: '100%',
        }}
      >
        <div style={{ color: '#28a745', marginBottom: '1rem' }}>
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" fill="#28a745" />
            <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <h1 style={{ color: '#333', marginBottom: '1rem' }}>Setup Complete</h1>

        <p style={{ color: '#555', fontSize: '16px', marginBottom: '1.5rem' }}>
          Thank you for completing your setup!
        </p>

        <div style={{
          backgroundColor: '#f8f9fa',
          borderRadius: '6px',
          padding: '1.25rem',
          marginBottom: '1.5rem',
          textAlign: 'left'
        }}>
          <h3 style={{ color: '#333', fontSize: '18px', marginTop: 0, marginBottom: '0.75rem' }}>
            Configuration Summary
          </h3>

          <div style={{ fontSize: '14px', color: '#555', marginBottom: '0.5rem' }}>
            <strong>Slack App:</strong> Successfully installed
          </div>

          <div style={{ fontSize: '14px', color: '#555' }}>
            <strong>Commands:</strong> <code>/page</code> command is now available
          </div>
        </div>

        <div style={{
          borderTop: '1px solid #eee',
          paddingTop: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}>
          <p style={{ color: '#555', fontSize: '14px', marginTop: 0 }}>
            You will receive a confirmation message on slack shortly.
          </p>

          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
            <a
              href="/dashboard"
              style={{
                backgroundColor: '#0066cc',
                color: '#fff',
                textDecoration: 'none',
                borderRadius: '4px',
                padding: '10px 20px',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              Go to Dashboard
            </a>

            <a
              href="https://slack.com"
              style={{
                backgroundColor: 'transparent',
                color: '#0066cc',
                textDecoration: 'none',
                border: '1px solid #0066cc',
                borderRadius: '4px',
                padding: '10px 20px',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              Return to Slack
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinalConfirmation;
